/**
 * Descripción: Gestor de peticiones Http
 *
 * @displayName HttpService
 */

import axios from 'axios';
import store from '@/store';
import BaseLocalHelper from '@/helpers/BaseLocalHelper';
import BaseNotificationsHelper from '@/helpers/BaseNotificationsHelper';

/**
 * Token para cancelar request's
 */
const axiosSource = axios.CancelToken.source();
const request = { cancel: axiosSource.cancel };

/**
 * Instancia Axios
 */
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  // timeout: 10000
});

/**
 * Inicia el loading (Middware)
 */
apiClient.interceptors.request.use(request => {
  BaseNotificationsHelper.StarLoading();
  return request;
});

/**
 * Intercepta las respuestas (Middware)
 */
apiClient.interceptors.response.use(
  response => {
    BaseNotificationsHelper.DoneLoading();
    let condition = response.config.url.includes('Grid');
    let GetCondition = response.config.url.includes('Get');
    let GetCondition2 = response.config.url.includes('Filter');
    if (
      !condition &&
      !GetCondition &&
      response.config.method != 'get' &&
      !GetCondition2
    ) {
      BaseNotificationsHelper.Message(
        false,
        response.response != undefined &&
          response.response.data.Message != undefined
          ? response.response.data.Message
          : BaseLocalHelper.$_MsgGenericSuccess,
        true,
        2500
      );
    }
    return response;
  },
  error => {
    if (error.response != undefined) {
      if (error.response.status === 401) {
        store.commit('authentication/LOGOUT', true, {
          root: true
        });
      } else {
        BaseNotificationsHelper.Message(
          true,
          error.response != undefined &&
            error.response.data.Message != undefined
            ? error.response.data.Message
            : BaseLocalHelper.$_MsgGenericError
        );
      }
    }

    BaseNotificationsHelper.DoneLoading();
    throw error;
  }
);

/**
 * Método Reutilizable de peticiones
 */
function httpRequest(method, url, request) {
  if (request != undefined) {
    return apiClient[method](url, request, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('user')}`
      }
    })
      .then(response => Promise.resolve(response))
      .catch(error => {
        console.log(error.message);
      });
  } else {
    return apiClient[method](url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('user')}`
      }
    })
      .then(response => Promise.resolve(response))
      .catch(error => {
        console.log(error.message);
      });
  }
}

export default {
  /**
   * Método GET
   */
  get(url, request) {
    return httpRequest('get', url, request);
  },

  /**
   * Método DELETE
   */
  delete(url, request) {
    return httpRequest('delete', url, request);
  },

  /**
   * Método POST
   */
  post(url, request) {
    return httpRequest('post', url, JSON.stringify(request));
  },

  /**
   * Método PUT
   */
  put(url, request) {
    return httpRequest('put', url, request);
  },

  /**
   * Método Cancelar
   */
  cancel() {
    request.cancel('Petición Cancelada');
  }
};
